import React from "react";
import HeroSection from "../../components/HeroSection/HeroSection";
import FeatureTextSection from "../../components/FeatureTextSection/FeatureTextSection";
import InformationCard from "../../components/InformationCard/InformationCard";
import { Row, Col } from "antd";
import JourneyTimeline from "../../components/JourneyTimeline/JourneyTimeline";
import { coreValues, journeyData, brand, certifications } from "./aboutus-data";

const AboutUs = () => {
  return (
    <div className="min-h-screen">
      <HeroSection
        title="Our Story"
        // brand="Crafting Excellence in Every Flavor"
        description="Crafting Excellence in Every Flavor"
        video="/videos/aboutus.webm"
      />

      <FeatureTextSection
        title="Our Mission"
        description="At Zesty Tongue, we're on a mission to revolutionize the food industry by bringing premium quality, ready-to-cook products to every kitchen. We believe in making gourmet cooking accessible while maintaining the highest standards of quality and food safety."
        customClassName="py-24 bg-white"
      />

      <section className="bg-gray-100 py-20">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-2">
            Our Core Values
          </h2>
          <div className="mx-auto w-24 h-1 bg-orange-500 rounded mb-2"></div>
        </div>
        <div className="w-11/12 max-w-7xl mx-auto">
          <Row gutter={32} className="flex flex-wrap justify-center">
            {coreValues.map((feature, idx) => (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={6}
                key={idx}
                className="mb-6 flex"
              >
                <InformationCard
                  feature={feature}
                  customClassName="bg-white h-full w-full rounded-xl shadow-md"
                />
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <JourneyTimeline journey={journeyData} />

      {/* Our Brands Section */}
      <section className="bg-gray-100 py-16">
        <div className="text-center mb-10">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-2">
            Our Brands
          </h2>
          <div className="mx-auto w-24 h-1 bg-orange-500 rounded mb-2"></div>
        </div>
        <div className="flex justify-center ">
          <div className="bg-white rounded-xl shadow-lg px-12 py-8 flex flex-col items-center w-full max-w-2xl">
            <img src={brand.logo} alt={brand.name} className="h-16 mb-4" />
            <div className="font-semibold text-xl md:text-2xl text-gray-800">
              {brand.name}
            </div>
          </div>
        </div>
      </section>

      {/* Our Certifications Section */}
      <section className="bg-gray-200 py-16">
        <div className="text-center mb-10">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-2">
            Our Certifications
          </h2>
          <div className="mx-auto w-24 h-1 bg-orange-500 rounded mb-2"></div>
        </div>
        <div className="flex flex-wrap justify-center gap-8 w-11/12 max-w-5xl mx-auto">
          {certifications.map((cert, idx) => (
            <div
              key={cert.label}
              className="bg-white rounded-xl shadow-md px-8 py-8 flex flex-col items-center w-full max-w-xs"
            >
              <img src={cert.img} alt={cert.label} className="h-12 mb-4" />
              <div className="font-semibold text-lg md:text-xl text-gray-800">
                {cert.label}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
